<template>
  <div class="container">
    <nyTit1 pathUrl="/xiaofeiData" />
    <div class="content">
<!--      <div class="list_item"></div><div class="list_item"></div><div class="list_item"></div>-->
      <div class="list_item"><iframe class="ifram" scrolling="yes" src="https://m.cnhnb.com/html/hbd/#/" ></iframe></div>
      <div class="list_item"><iframe class="ifram ifram2" src="https://m.cnhnb.com/html/hbd/#/categoryInsight"></iframe></div>
      <div class="list_item"><iframe class="ifram ifram3" src="https://m.cnhnb.com/html/hbd/#/supermarket/production" ></iframe></div>

    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";


import { useRouter } from 'vue-router'
import nyTit1 from '../components/nyTit1.vue'
    const { proxy } = getCurrentInstance();
    
const router = useRouter();
    const timer = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
  
    });
function clickReturn() {
  console.log("上一页");
  router.go(-1);
}
    onMounted(() => {


    })
    onUnmounted(() => {
      // 清理资源

    });
    onBeforeUnmount(() => {

    })



</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  position: relative;
  //顶部标题

  .content{
    position: fixed;
    top: 180px;
    left: 0;
    width: 100%;
    height: calc(100% - 180px);
    display: flex;
    .list_item{
      flex: 1;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      //transform: scale(2.2);
      border: 10px solid #03476F;
      margin: 0 20px;
      .ifram{
        width: 1200px;
        height: 950px;
        transform: scale(1.6);
        margin-top:380px;
        border: 0;
      }
      //.ifram2{
      //  width: 1200px;
      //}
      //.ifram3{
      //  height: 480px;
      //  margin-top: 480px;
      //}
    }
  }
}

</style>
